export const HORSE = 'horse';
export const DISCIPLINE = 'discipline';
export const CHARACTER = 'character';
export const AVAILABILITY = 'availability';
export const DESCRIPTION = 'description';
export const DESCRIPTION_RIDER = 'horsetype';
export const DESCRIPTION_HORSE = 'description-horse';
export const LOCATION = 'stable-location';
export const PRICING = 'pricing';
export const PHOTOS = 'gallery';
export const EQUIPMENT = 'equipment';
export const BOOSTING_CH = 'boost-ch';
export const BOOSTING_DE = 'boost-de';
export const CHECKOUT = 'checkout';

export const LISTING_PAGE_PENDING_APPROVAL_VARIANT = 'pending-approval';
export const LISTING_PAGE_DRAFT_VARIANT = 'draft';

export const LISTING_PAGE_PARAM_TAB_OVERVIEW = 'overview';
export const LISTING_PAGE_PARAM_TAB_HORSE_OVERVIEW = 'horse-overview';
export const LISTING_PAGE_PARAM_TAB_STABLE_OVERVIEW = 'stable-overview';
export const LISTING_PAGE_PARAM_TAB_PRICING_OVERVIEW = 'pricing-overview';

export const LISTING_PAGE_PARAM_TYPE_NEW = 'new';
export const LISTING_PAGE_PARAM_TYPE_DRAFT = 'draft';
export const LISTING_PAGE_PARAM_TYPE_DRAFT_INTERRUPTED = 'draftInterrupted';
export const LISTING_PAGE_PARAM_TYPE_EDIT = 'edit';
export const LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT = 'editAndRedirect';
export const LISTING_PAGE_PARAM_TYPES = [
    LISTING_PAGE_PARAM_TYPE_NEW,
    LISTING_PAGE_PARAM_TYPE_DRAFT,
    LISTING_PAGE_PARAM_TYPE_DRAFT_INTERRUPTED,
    LISTING_PAGE_PARAM_TYPE_EDIT,
    LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
];

export const HORSE_TYPE_JUNGPFERD_IN_AUSBILDUNG = 'jungpferdInAusbildung';
export const HORSE_TYPE_FREIZEITPFERD = 'freizeitpferd';
export const HORSE_TYPE_HORSE_KIND = 'horseKind';
export const HORSE_TYPE_SENIOR = 'senior';

export const EDIT_LISTING_TAB_START_DATE = 'startdate';
export const EDIT_LISTING_TAB_REQUIREMENTS = 'requirements';
export const EDIT_LISTING_TAB_EXPERIENCE = 'experience';
export const EDIT_LISTING_TAB_ACTIVITIES = 'activities';
export const EDIT_LISTING_TAB_DISCIPLINES = 'disciplines';
export const EDIT_LISTING_TAB_QUALIFICATIONS = 'qualifications';
export const EDIT_LISTING_TAB_SKILLS = 'skills';
export const EDIT_LISTING_TAB_STABLE_FACILITIES = 'stable-facilities';
export const EDIT_LISTING_TAB_STABLE_OFFER = 'stable-offer';
export const EDIT_LISTING_TAB_INFO = 'info';

export const EDIT_LISTING_STEPS_MAP = {
    [LISTING_PAGE_PARAM_TAB_OVERVIEW]: { tab: 1, step: 0 },
    [DESCRIPTION_RIDER]: { tab: 1, step: 1 },
    [EDIT_LISTING_TAB_START_DATE]: { tab: 1, step: 2 },
    [EDIT_LISTING_TAB_REQUIREMENTS]: { tab: 1, step: 3 },
    [EDIT_LISTING_TAB_EXPERIENCE]: { tab: 1, step: 4 },
    [EDIT_LISTING_TAB_ACTIVITIES]: { tab: 1, step: 5 },
    [EDIT_LISTING_TAB_DISCIPLINES]: { tab: 1, step: 6 },
    [EDIT_LISTING_TAB_QUALIFICATIONS]: { tab: 1, step: 7 },
    [EDIT_LISTING_TAB_SKILLS]: { tab: 1, step: 8 },

    [LISTING_PAGE_PARAM_TAB_STABLE_OVERVIEW]: { tab: 2, step: 0 },
    [LOCATION]: { tab: 2, step: 1 },
    [EDIT_LISTING_TAB_STABLE_FACILITIES]: { tab: 2, step: 2 },
    [EDIT_LISTING_TAB_STABLE_OFFER]: { tab: 2, step: 3 },

    [LISTING_PAGE_PARAM_TAB_HORSE_OVERVIEW]: { tab: 3, step: 0 },
    [PHOTOS]: { tab: 3, step: 1 },
    [EDIT_LISTING_TAB_INFO]: { tab: 3, step: 2 },
    [DESCRIPTION]: { tab: 3, step: 3 },

    [LISTING_PAGE_PARAM_TAB_PRICING_OVERVIEW]: { tab: 4, step: 0 },
    [PRICING]: { tab: 4, step: 1 },
    [BOOSTING_CH]: { tab: 4, step: 2 }, // same step, different country.
    [BOOSTING_DE]: { tab: 4, step: 2 }, // same step, different country.
    [CHECKOUT]: { tab: 4, step: 2 },
};

export const EDIT_LISTING_STEPS_PER_TAB = {
    1: 8,
    2: 3,
    3: 3,
    4: 1,
};
